<template>
    <div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <a-button icon="sync" :loading="loading" @click="getData">刷新</a-button>
        </div>
        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="微信用户来源查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">服务商：</div>
                        <a-select v-model="query.facilitatorId" @change="getData">
                            <a-select-option v-for="(item, index) in facilitatorList" :key="index"
                                :value="item.facilitatorId">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>

                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">查询日期：</div>
                        <a-date-picker mode="date" v-model="query.startDay" :disabledDate="disabledStartDate"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
                        <span style="width: 20px;text-align: center;">-</span>
                        <a-date-picker mode="date" v-model="query.endDay" :disabledDate="disabledEndDate"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
                    </div>
                    <div class="qinang-search-col-3"></div>
                </div>
                <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
                    <a-button type="primary" icon="search" @click="getData" :loading="loading">查询</a-button>
                    <a-button icon="redo" :loading="loading" @click="resetQuery"
                        style="margin-left: 14px;">重置</a-button>
                </div>


            </a-collapse-panel>
        </a-collapse>
        <a-spin :spinning="loading" tip="数据加载中...">
            <div class="chart-row">
                <div class="qinang-card chart-card chart-card--pie">
                    <div class="pie-header">
                        <span class="pie-title">访问来源分布</span>
                        <a-radio-group v-model="viewMode" button-style="solid" size="small">
                            <a-radio-button value="pie">饼状图</a-radio-button>
                            <a-radio-button value="bar">柱状图</a-radio-button>
                        </a-radio-group>
                    </div>
                    <div v-show="viewMode === 'pie'" id="wxSourcePie" class="chart-fill"></div>
                    <div v-show="viewMode === 'bar'" id="wxSourceBar" class="chart-fill"></div>
                </div>

                <div class="qinang-card chart-card chart-card--rank">
                    <div class="rank-title">访问来源排行榜</div>
                    <div id="wxSourceRank" class="chart-fill"></div>
                </div>
            </div>
        </a-spin>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    data() {
        return {
            selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu') || '数据看板',
            selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu') || '微信用户来源',
            query: {
                startDay: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
                endDay: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
                facilitatorId: undefined,

            },
            sourceMap: {
                1: '小程序历史列表', 2: '搜索', 3: '会话', 4: '扫一扫二维码', 5: '公众号主页',
                6: '聊天顶部', 7: '系统桌面', 8: '小程序主页', 9: '附近的小程序', 10: '其他',
                11: '模板消息', 12: '客服消息', 13: '公众号菜单', 14: 'APP分享', 15: '支付完成页',
                16: '长按识别二维码', 17: '相册选取二维码', 18: '公众号文章', 19: '钱包', 20: '卡包',
                21: '小程序内卡券', 22: '其他小程序', 23: '其他小程序返回', 24: '卡券适用门店列表',
                25: '搜索框快捷入口', 26: '小程序客服消息', 27: '公众号下发', 28: '系统会话菜单',
                29: '任务栏-最近使用', 30: '长按小程序菜单圆点', 31: '连wifi成功页', 32: '城市服务',
                33: '微信广告', 34: '其他移动应用', 35: '发现入口-我的小程序', 36: '任务栏-我的小程序',
                37: '微信圈子', 38: '手机充值', 39: 'H5', 40: '插件', 41: '大家在用', 42: '发现页',
                43: '浮窗', 44: '附近的人', 45: '看一看', 46: '朋友圈', 47: '企业微信', 48: '视频',
                49: '收藏', 50: '微信红包', 51: '微信游戏中心', 52: '摇一摇', 53: '公众号导购消息',
                54: '识物', 55: '小程序订单', 56: '小程序直播', 57: '群工具'
            },
            chartData: [],
            viewMode: 'bar',
            loading: false,
            facilitatorList: [],

        };
    },
    methods: {
        // 拉取当前账号可访问的服务商列表,默认选中第一个并触发首次查询
        async apiFacilitatorListForStaff() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorListForStaff, { staffId: window.sessionStorage.getItem('staffId') });
            if (res.code == 200) {
                this.facilitatorList = res.data
                if (this.facilitatorList.length) {
                    this.query.facilitatorId = this.facilitatorList[0].facilitatorId
                    this.getData()   // 用默认服务商查一次
                } else {
                    this.query.facilitatorId = undefined
                    this.$message.warning('当前账号无可用的服务商')
                }
            } else {
                this.$message.error(res.msg)
            }
        },


        // 起始日期禁用规则:不能选今天及以后
        disabledStartDate(current) {
            if (current && current > moment().subtract(1, 'days').endOf('day')) return true;
            return false;
        },
        // 结束日期禁用规则:不能选今天及以后,且只能在 [起始日, 起始日+6天] 区间内
        disabledEndDate(current) {
            if (current && current > moment().subtract(1, 'days').endOf('day')) return true;
            if (this.query.startDay) {
                const min = moment(this.query.startDay).startOf('day');
                const max = moment(this.query.startDay).add(6, 'days').endOf('day');
                if (current && (current < min || current > max)) return true;
            }
            return false;
        },
        // 按日期区间+服务商请求微信访问来源数据,更新 chartData 并渲染图表
        async getData() {
            let start = this.query.startDay;
            let end = this.query.endDay;
            if (!start || !end) {
                const y = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                start = end = y;
            }
            if (start && end) {
                const diff = moment(end).startOf('day').diff(moment(start).startOf('day'), 'days');
                if (diff > 6) {
                    this.$message.warning('查询范围最大为一周(7天)');
                    return;
                }
            }
            this.loading = true;
            try {
                const { data: res } = await this.$http.post(this.navigation.apiDataChartWechatSource, {
                    startDate: (start || '').substring(0, 10), 
                    endDate: (end || '').substring(0, 10),
                    facilitatorId: this.query.facilitatorId
                });


                if (res.code == 200) {
                    if (res.data && res.data.bindMiniProgram === false) {
                        this.$message.warning('该服务商未绑定小程序');
                    }
                    const list = (res.data && res.data.list) || [];
                    let pvList = [];
                    list.forEach(item => {
                        if (item.index === 'access_source_session_cnt') pvList = item.item_list || [];
                    });
                    this.chartData = pvList
                        .map(it => ({
                            key: it.key,
                            name: this.sourceMap[it.key] || ('未知来源(' + it.key + ')'),
                            value: Number(it.value)
                        }))
                        .sort((a, b) => b.value - a.value);
                    if (this.viewMode === 'pie') this.renderPie();
                    else this.renderFullBar();
                    this.renderBar();   // 右侧 Top10 照旧
                } else {
                    this.$message.error(res.msg);
                }
            } catch (e) {
                this.$message.error('请求失败');
            } finally {
                this.loading = false;   // 无论成功/失败/异常,都关闭遮罩
            }
        },

        // 渲染左侧饼图(访问来源分布)
        renderPie() {
            const dom = document.getElementById('wxSourcePie');
            if (!this.pieChart) this.pieChart = this.$echarts.init(dom);
            this.pieChart.setOption({
                tooltip: { trigger: 'item', formatter: (p) => `${p.name}<br/>数量: ${p.value} (${p.percent}%)` },
                legend: { type: 'scroll', orient: 'vertical', left: 10, top: 'middle', itemWidth: 10, itemHeight: 10, textStyle: { fontSize: 12 } },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: ['32%', '72%'],
                    center: ['55%', '50%'],
                    avoidLabelOverlap: false,
                    itemStyle: { borderRadius: 8, borderColor: '#fff', borderWidth: 2 },
                    label: { show: false, position: 'center' },
                    emphasis: { label: { show: true, fontSize: 18, fontWeight: 'bold' } },
                    labelLine: { show: false },
                    data: this.chartData.map(item => ({ name: item.name, value: item.value }))
                }]
            });
        },
        // 渲染右侧 Top10 排行榜(横向条形图)
        renderBar() {
            const dom = document.getElementById('wxSourceRank');
            if (!this.barChart) this.barChart = this.$echarts.init(dom);
            const top = this.chartData.slice(0, 5);
            const total = this.chartData.reduce((s, i) => s + i.value, 0);
            this.barChart.setOption({
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
                grid: { left: 10, right: 130, top: 10, bottom: 10, containLabel: true },
                xAxis: { type: 'value', show: false },
                yAxis: {
                    type: 'category',
                    data: top.map(item => item.name).reverse(),
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { color: '#333', fontSize: 13 }
                },
                series: [{
                    type: 'bar',
                    data: top.map(item => item.value).reverse(),
                    barWidth: 20,
                    itemStyle: { color: '#52c41a', borderRadius: 7 },
                    label: {
                        show: true,
                        position: 'right',
                        color: '#333',
                        fontSize: 12,
                        formatter: (p) => {
                            const pct = total > 0 ? ((p.value / total) * 100).toFixed(2) : '0.00';
                            return `${p.value}  |  ${pct}%`;
                        }
                    }
                }]
            });
        },


        // 渲染左侧完整柱图(展示全部来源,非 Top10)
        renderFullBar() {
            const dom = document.getElementById('wxSourceBar');
            if (!this.fullBarChart) this.fullBarChart = this.$echarts.init(dom);
            const total = this.chartData.reduce((s, i) => s + i.value, 0);
            this.fullBarChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: (params) => {
                        const p = params[0];
                        const pct = total > 0 ? ((p.value / total) * 100).toFixed(2) : '0.00';
                        return `${p.name}<br/>数量: ${p.value} (${pct}%)`;
                    }
                },
                grid: { left: 50, right: 20, top: 20, bottom: 60, containLabel: true },
                xAxis: {
                    type: 'category',
                    data: this.chartData.map(i => i.name),
                    axisLine: { lineStyle: { color: '#ccc' } },
                    axisTick: { show: false },
                    axisLabel: { color: '#333', fontSize: 12, interval: 0, rotate: 0 }
                },
                yAxis: {
                    type: 'value',
                    axisLine: { show: false },
                    axisTick: { show: false },
                    splitLine: { lineStyle: { color: '#eee' } },
                    axisLabel: { color: '#999', fontSize: 12 }
                },
                series: [{
                    type: 'bar',
                    data: this.chartData.map(i => i.value),
                    barWidth: 40,
                    itemStyle: { color: '#5470c6', borderRadius: [4, 4, 0, 0] }
                }]
            });
        },

        // 窗口缩放时重算所有图表尺寸,防止变形
        resizeCharts() {
            if (this.pieChart) this.pieChart.resize();
            if (this.fullBarChart) this.fullBarChart.resize();
            if (this.barChart) this.barChart.resize();
        },

        // 重置查询条件:日期清空后重新查询(兜底为昨天)
        resetQuery() {

            this.query.startDay = '';
            this.query.endDay = '';
            this.getData();
        }
    },
    watch: {
        // 监听起始日:变化后让结束日自动跟随(起始+6天,超昨天取昨天)
        'query.startDay'(val) {
            if (!val) return;
            const max = moment(val).add(6, 'days');
            const yesterday = moment().subtract(1, 'days').endOf('day');
            const end = max.isAfter(yesterday) ? yesterday : max;
            this.query.endDay = end.format('YYYY-MM-DD HH:mm:ss');
        },
        // 监听视图切换:饼图/柱图互斥,切换时释放旧实例避免内存泄漏
        viewMode(val) {
            this.$nextTick(() => {
                if (val === 'pie') {
                    if (this.fullBarChart) { this.fullBarChart.dispose(); this.fullBarChart = null; }
                    this.renderPie();
                } else {
                    if (this.pieChart) { this.pieChart.dispose(); this.pieChart = null; }
                    this.renderFullBar();
                }
            });
        }
    },

    // 挂载:拉取服务商列表,并绑定窗口 resize 监听
    mounted() {
        this.apiFacilitatorListForStaff();

        this._onResize = () => this.resizeCharts();
        window.addEventListener('resize', this._onResize);
    },
    // 销毁前:解绑 resize 监听,释放所有 ECharts 实例
    beforeDestroy() {
        window.removeEventListener('resize', this._onResize);
        if (this.pieChart) { this.pieChart.dispose(); this.pieChart = null; }
        if (this.fullBarChart) { this.fullBarChart.dispose(); this.fullBarChart = null; }
        if (this.barChart) { this.barChart.dispose(); this.barChart = null; }

    },
    // keep-alive 激活时:有缓存数据则重绘图表并校正尺寸
    activated() {
        if (this.chartData.length) {
            if (this.viewMode === 'pie') this.renderPie();
            else this.renderFullBar();
            this.renderBar();
            this.resizeCharts();
        }
    }

};
</script>

<style scoped>
.qinang-search-row {
    margin-bottom: 12px;
}

.qinang-card {
    background: #fff;
    padding: 16px;
    border-radius: 4px;
}

/* 图表区:横排,窄屏出横向滚动条,图表保持最小宽不变形 */
.chart-row {
    display: flex;
    gap: 16px;
    height: calc(100vh - 260px);
    margin-top: 16px;
    overflow-x: auto;
}

.chart-card {
    margin-top: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.chart-card--pie {
    flex: 2 1 600px;
    min-width: 600px;
}

.chart-card--rank {
    flex: 1 1 300px;
    min-width: 300px;
}

.rank-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
}

.chart-fill {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
}

.pie-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px;
    margin-bottom: 12px;
}

.pie-title {
    font-size: 16px;
    font-weight: 600;
}
</style>
